<template>
  <header class="header">
    <div class="header-inner">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/logo/logo2.png" alt="로고" />
        </router-link>
      </div>

      <nav class="nav-pc">
        <ul class="nav-menu">
          <li class="nav-item" v-for="menu in menuList" :key="menu.title">
            <router-link :to="menu.path" class="nav-title">{{ menu.title }}</router-link>
            <ul class="sub-menu">
              <li v-for="sub in menu.subMenu" :key="sub.name">
                <router-link :to="sub.path">{{ sub.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <div class="phone-box">
        <a href="tel:1599-0648">1599-0648</a>
      </div>

      <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <div class="nav-mobile" :class="{ open: isMobileMenuOpen }">
      <div class="mobile-menu-inner">
        <ul class="mobile-menu">
          <li v-for="menu in menuList" :key="menu.title" class="mobile-menu-item">
            <button class="mobile-menu-title" @click="toggleSubMenu(menu.title)" :class="{ active: openSubMenu === menu.title }">
              {{ menu.title }}
              <span class="arrow"></span>
            </button>
            <ul class="mobile-sub-menu" :class="{ open: openSubMenu === menu.title }">
              <li v-for="sub in menu.subMenu" :key="sub.name">
                <router-link :to="sub.path" @click="closeMobileMenu">{{ sub.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
        <div class="mobile-phone">
          <a href="tel:1599-0648">1599-0648</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMobileMenuOpen: false,
      openSubMenu: null,
      menuList: [
        {
          title: '사업안내',
          path: '/business',
          subMenu: [
            { name: '사업개요', path: '/business/overview' },
            { name: '회사소개', path: '/business/company' },
            { name: '브랜드소개', path: '/business/brand' },
            { name: '오시는길', path: '/business/location' }
          ]
        },
        {
          title: '프리미엄',
          path: '/premium',
          subMenu: [
            { name: '입지안내', path: '/premium/location' },
            { name: '프리미엄8', path: '/premium/premium8' }
          ]
        },
        {
          title: '단지안내',
          path: '/complex',
          subMenu: [
            { name: '단지설계', path: '/complex/design' },
            { name: '단지 및 동호배치', path: '/complex/layout' },
            { name: '스페셜 커뮤니티', path: '/complex/community' },
            { name: '시스템', path: '/complex/system' },
            { name: '이동통신 설비설치 협의 결과서', path: '/complex/telecom' }
          ]
        },
        {
          title: '분양안내',
          path: '/sale',
          subMenu: [
            { name: '공급안내', path: '/sale/supply' }
          ]
        },
        {
          title: '세대안내',
          path: '/unit',
          subMenu: [
            { name: '타입안내', path: '/unit/type' },
            { name: '인테리어', path: '/unit/interior' }
          ]
        },
        {
          title: '고객센터',
          path: '/support',
          subMenu: [
            { name: '관심고객등록', path: '/support' }
          ]
        }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (!this.isMobileMenuOpen) {
        this.openSubMenu = null
      }
    },
    toggleSubMenu(title) {
      this.openSubMenu = this.openSubMenu === title ? null : title
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.openSubMenu = null
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.header-inner {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  flex-shrink: 0;
}

.logo img {
  height: 45px;
}

.nav-pc {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 5px;
}

.nav-item {
  position: relative;
}

.nav-title {
  display: block;
  padding: 12px 22px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  letter-spacing: -0.3px;
}

.nav-title:hover {
  color: var(--main-color1);
}

.sub-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  min-width: 200px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 12px 0;
  list-style: none;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  margin-top: 10px;
}

.sub-menu::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 0;
  width: 100%;
  height: 10px;
}

.nav-item:hover .sub-menu {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.sub-menu li a {
  display: block;
  padding: 11px 24px;
  font-size: 14px;
  color: #555;
  text-decoration: none;
  transition: all 0.2s;
  white-space: nowrap;
  font-weight: 400;
}

.sub-menu li a:hover {
  color: var(--main-color1);
  background: linear-gradient(90deg, rgba(0, 171, 205, 0.08) 0%, transparent 100%);
  padding-left: 28px;
}

.phone-box {
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  border-radius: 50px;
  padding: 12px 28px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.phone-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 171, 205, 0.3);
}

.phone-box a {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0.3px;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 6px;
  padding: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 6px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -6px);
}

.nav-mobile {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100vh - 80px);
  background: #fff;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
}

.nav-mobile.open {
  transform: translateX(0);
}

.mobile-menu-inner {
  padding: 30px 25px;
}

.mobile-menu {
  list-style: none;
}

.mobile-menu-item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-menu-title {
  width: 100%;
  padding: 20px 0;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  letter-spacing: -0.3px;
}

.mobile-menu-title .arrow {
  width: 8px;
  height: 8px;
  border-right: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
  transform: rotate(45deg);
  transition: transform 0.3s;
}

.mobile-menu-title.active {
  color: var(--main-color1);
}

.mobile-menu-title.active .arrow {
  transform: rotate(-135deg);
  border-color: var(--main-color1);
}

.mobile-sub-menu {
  list-style: none;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  background: #fafafa;
  margin: 0 -25px;
  padding: 0 25px;
}

.mobile-sub-menu.open {
  max-height: 500px;
}

.mobile-sub-menu li a {
  display: block;
  padding: 14px 20px;
  font-size: 15px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s;
}

.mobile-sub-menu li a:hover,
.mobile-sub-menu li a:active {
  color: var(--main-color1);
}

.mobile-phone {
  margin-top: 40px;
  text-align: center;
}

.mobile-phone a {
  display: inline-block;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  color: #fff;
  padding: 16px 50px;
  border-radius: 50px;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
}

@media (max-width: 1280px) {
  .header-inner {
    padding: 0 30px;
  }

  .nav-title {
    padding: 12px 16px;
    font-size: 15px;
  }
}

@media (max-width: 1024px) {
  .nav-pc,
  .phone-box {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .nav-mobile {
    display: block;
  }

  .header-inner {
    height: 65px;
    padding: 0 20px;
  }

  .logo img {
    height: 38px;
  }

  .nav-mobile {
    top: 65px;
    height: calc(100vh - 65px);
  }
}
</style>